import React from 'react';
import BaseModal from '../common/BaseModal';

const ComposeModal = ({
  isOpen,
  onClose,
  replyTo,
  newMessage,
  setNewMessage,
  users,
  locations,
  onSend,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSend();
  };

  const footer = (
    <>
      <button
        type="button"
        onClick={onClose}
        style={{ padding: '6px 12px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , cursor: 'pointer', fontSize: '12px' }}
      >
        Anuluj
      </button>
      <button
        type="submit"
        form="compose-form"
        style={{ padding: '6px 12px', backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', color: 'var(--text)' , cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}
      >
        Wyslij
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={replyTo ? `Odpowiedz: ${replyTo.tytul}` : 'Nowa wiadomosc'}
      subtitle="Wyslij wiadomosc do uzytkownika lub lokalizacji"
      headerIcon="MSG"
      headerStyle={{ backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', color: 'var(--text)' }}
      size="md"
      footer={footer}
    >
      <form id="compose-form" onSubmit={handleSubmit}>
        {/* Tytul */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '12px', color: 'var(--text-secondary)' }}>
            Tytul *
          </label>
          <input
            type="text"
            value={newMessage.tytul}
            onChange={(e) => setNewMessage({ ...newMessage, tytul: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box' }}
            placeholder="Wpisz tytul wiadomosci"
          />
        </div>

        {/* Odbiorca */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '12px', color: 'var(--text-secondary)' }}>
            Odbiorca
          </label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <select
              value={newMessage.odbiorca_login}
              onChange={(e) => setNewMessage({ ...newMessage, odbiorca_login: e.target.value, odbiorca_location_id: '', is_global: false })}
              disabled={newMessage.is_global || newMessage.odbiorca_location_id}
              style={{ flex: 1, padding: '10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px' }}
            >
              <option value="">-- Uzytkownik --</option>
              {users.map(u => (
                <option key={u.login} value={u.login}>{u.login} ({u.typ})</option>
              ))}
            </select>

            <select
              value={newMessage.odbiorca_location_id}
              onChange={(e) => setNewMessage({ ...newMessage, odbiorca_location_id: e.target.value, odbiorca_login: '', is_global: false })}
              disabled={newMessage.is_global || newMessage.odbiorca_login}
              style={{ flex: 1, padding: '10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px' }}
            >
              <option value="">-- Lokalizacja --</option>
              {locations.map(loc => (
                <option key={loc.id} value={loc.id}>{loc.nazwa}</option>
              ))}
            </select>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={newMessage.is_global}
              onChange={(e) => setNewMessage({ ...newMessage, is_global: e.target.checked, odbiorca_login: '', odbiorca_location_id: '' })}
              style={{ width: '16px', height: '16px' }}
            />
            <span style={{ fontSize: '12px' }}>Wyslij do wszystkich</span>
          </label>
        </div>

        {/* Priorytet */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '12px', color: 'var(--text-secondary)' }}>
            Priorytet
          </label>
          <select
            value={newMessage.priorytet}
            onChange={(e) => setNewMessage({ ...newMessage, priorytet: e.target.value })}
            style={{ width: '100%', padding: '10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '12px' }}
          >
            <option value="normalny">Normalny</option>
            <option value="wazny">Wazny</option>
            <option value="pilny">Pilny</option>
          </select>
        </div>

        {/* Tresc */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '12px', color: 'var(--text-secondary)' }}>
            Tresc *
          </label>
          <textarea
            value={newMessage.tresc}
            onChange={(e) => setNewMessage({ ...newMessage, tresc: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '13px', minHeight: '120px', resize: 'vertical', boxSizing: 'border-box' }}
            placeholder="Wpisz tresc wiadomosci..."
          />
        </div>
      </form>
    </BaseModal>
  );
};

export default ComposeModal;
